module.exports = __webpack_public_path__ + "img/share-btn.bc137493.svg";